// This components is a smaller version of the project table, it is used to display a list of projects in a compact way

import { MiniProjectList } from "@/components/Projects/Table/ProjectList";
import { SectionDiv } from "./Components/SectionDiv";

export function MiniProjectListContainer() {
    return (
        <SectionDiv padding="p-0" margin="m-0" className="overflow-y-auto">
            <h3 className="px-4 py-2 mx-auto">Project List:</h3>
            <MiniProjectList />
        </SectionDiv>
    )
}